module.exports = __webpack_public_path__ + "onboarding-feed-vsts.a2be48bb29ec48760d1b9731f31f060b.hashedasset.svg";